import React from "react";
import { Button } from "@mui/material";
import { CircularProgress } from "@mui/material";
interface CustomButtonProps {
  loader?: boolean;
  endIcon?: React.ReactNode;
  name: string;
  onClick?: () => void;
  variant?: "text" | "contained" | "outlined";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  style?: React.CSSProperties;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  loader,
  endIcon,
  name,
  onClick,
  variant = "contained",
  size = "small",
  disabled,
  fullWidth = false,
  className,
  color = "primary",
  style,
}) => {
  const buttonStyle: React.CSSProperties = {
    minHeight: 30,
    textTransform: "none",
    ...(variant === "contained" ? { background: "#114C5A" } : {}),
    ...style,
  };

  return (
    <Button
      style={buttonStyle}
      className={className}
      fullWidth={fullWidth}
      disabled={disabled}
      color={color}
      size={size}
      variant={variant}
      onClick={onClick}
      endIcon={
        loader ? <CircularProgress color="inherit" size={20} /> : endIcon
      }
    >
      {name}
    </Button>
  );
};

export default CustomButton;
